import { SERVICE_NAME } from "@/config/serviceNames";
import { EntityType, Module } from "@/constants";
import { requests } from ".";

export enum BlacklistType {
  ExactEmail = "exact_email",
  EmailTld = "email_tld",
  PhonePrefix = "phone_prefix",
  IPAddress = "ip_address",
  Fingerprint = "fingerprint",
}

export interface BlacklistEntry {
  type: BlacklistType;
  value: string;
}

type BlacklistPayload = {
  type: BlacklistType;
  exactEmail?: string;
  emailTld?: string;
  phonePrefix?: string;
  ipAddress?: string;
  fingerprint?: string;
};

const REQUEST_LOG_META = {
  module: Module.COMPANY,
  entityType: EntityType.OTHERS,
  entityId: "blacklists",
};

function buildBlacklistPayload(entry: BlacklistEntry): BlacklistPayload {
  const trimmedValue = entry.value.trim();

  switch (entry.type) {
    case BlacklistType.ExactEmail:
      return { type: entry.type, exactEmail: trimmedValue };
    case BlacklistType.EmailTld:
      return { type: entry.type, emailTld: trimmedValue };
    case BlacklistType.PhonePrefix:
      return { type: entry.type, phonePrefix: trimmedValue };
    case BlacklistType.IPAddress:
      return { type: entry.type, ipAddress: trimmedValue };
    case BlacklistType.Fingerprint:
      return { type: entry.type, fingerprint: trimmedValue };
    default:
      throw new Error(`Unsupported blacklist type: ${entry.type}`);
  }
}

const BlacklistsService = {
  listEntries() {
    return requests(SERVICE_NAME.COMPANIES_API).get("blacklists/entries");
  },

  addEntry(entry: BlacklistEntry) {
    return requests(SERVICE_NAME.COMPANIES_API)
      .log(REQUEST_LOG_META)
      .post("blacklists/entries", buildBlacklistPayload(entry));
  },

  removeEntry(entry: BlacklistEntry) {
    return requests(SERVICE_NAME.COMPANIES_API)
      .log(REQUEST_LOG_META)
      .delete("blacklists/entries", {
        data: buildBlacklistPayload(entry),
      });
  },
};

export default BlacklistsService;
